import Group from '@/models/Organization/Group';

export function getGroupNameForUser(groups: Group[], authId: string): string {
  return (
    groups.find((group) =>
      group.group_value?.some((user) => user.auth_id === authId),
    )?.group_name ?? ''
  );
}
